const CODE128_PATTERNS = {
  startB: '11010010000',
  stop: '1100011101011',
  chars: [
    '11011001100',
    '11001101100',
    '11001100110',
    '10010011000',
    '10010001100',
    '10001001100',
    '10011001000',
    '10011000100',
    '10001100100',
    '11001001000',
    '11001000100',
    '11000100100',
    '10110011100',
    '10011011100',
    '10011001110',
    '10111001100',
    '10011101100',
    '10011100110',
    '11001110010',
    '11001011100',
    '11001001110',
    '11011100100',
    '11001110100',
    '11101101110',
    '11101001100',
    '11100101100',
    '11100100110',
    '11101100100',
    '11100110100',
    '11100110010',
    '11011011000',
    '11011000110',
    '11000110110',
    '10100011000',
    '10001011000',
    '10001000110',
    '10110001000',
    '10001101000',
    '10001100010',
    '11010001000',
    '11000101000',
    '11000100010',
    '10110111000',
    '10110001110',
    '10001101110',
    '10111011000',
    '10111000110',
    '10001110110',
    '11101110110',
    '11010001110',
    '11000101110',
    '11011101000',
    '11011100010',
    '11011101110',
    '11101011000',
    '11101000110',
    '11100010110',
    '11101101000',
    '11101100010',
    '11100011010',
    '11101111010',
    '11001000010',
    '11110001010',
    '10100110000',
    '10100001100',
    '10010110000',
    '10010000110',
    '10000101100',
    '10000100110',
    '10110010000',
    '10110000100',
    '10011010000',
    '10011000010',
    '10000110100',
    '10000110010',
    '11000010010',
    '11001010000',
    '11110111010',
    '11000010100',
    '10001111010',
    '10100111100',
    '10010111100',
    '10010011110',
    '10111100100',
    '10011110100',
    '10011110010',
    '11110100100',
    '11110010100',
    '11110010010',
    '11011011110',
    '11011110110',
    '11110110110',
    '10101111000',
    '10100011110',
    '10001011110',
    '10111101000',
    '10111100010',
    '11110101000',
    '11110100010',
    '10111011110',
    '10111101110',
    '11101011110',
    '11110101110',
  ],
} as const;

export interface BarcodeBar {
  x: number;
  width: number;
}

export const generateBarcodeBars = (barcodeId: string): BarcodeBar[] => {
  const data = barcodeId;
  let checksum = 104;
  let pattern = CODE128_PATTERNS.startB;

  for (let index = 0; index < data.length; index += 1) {
    const charCode = data.charCodeAt(index) - 32;
    if (charCode >= 0 && charCode < CODE128_PATTERNS.chars.length) {
      pattern += CODE128_PATTERNS.chars[charCode];
      checksum += charCode * (index + 1);
    }
  }

  const checksumIndex = checksum % 103;
  pattern += CODE128_PATTERNS.chars[checksumIndex];
  pattern += CODE128_PATTERNS.stop;

  const barWidth = 2;
  const bars: BarcodeBar[] = [];
  let xPos = 0;
  let currentBarStart = -1;

  for (let index = 0; index < pattern.length; index += 1) {
    if (pattern[index] === '1') {
      if (currentBarStart === -1) {
        currentBarStart = xPos;
      }
    } else if (currentBarStart !== -1) {
      bars.push({ x: currentBarStart, width: xPos - currentBarStart });
      currentBarStart = -1;
    }

    xPos += barWidth;
  }

  if (currentBarStart !== -1) {
    bars.push({ x: currentBarStart, width: xPos - currentBarStart });
  }
  return bars;
};
